module.exports = __webpack_public_path__ + "fonts/iconfont.d73b1d61.woff";